import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCartContext } from '../Context/CartContext';
import ItemCart from '../ItemCart/ItemCart';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import imgCarro from "../../Imagenes/carrovacio.png";
import imgCarro1 from "../../Imagenes/carrolleno.png";
import toast, { Toaster } from 'react-hot-toast';
import "../CartWidget/CartWidget.css";

const CartWidget = ({ selectedSize, acomp }) => {
    const { totalProducts, cart, totalPrice, moduloBebida } = useCartContext();
    const [show, setShow] = useState(false);
    const [iconCart, setIconCart] = useState(totalProducts === 0 ? imgCarro : imgCarro1);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleIcon = () => {
        if (totalProducts() === 0) {
            setIconCart(imgCarro);
        } else {
            setIconCart(imgCarro1);
        }
    };

    useEffect(() => {
        handleIcon();
    }, [totalProducts]);

    return (
        <>  
            {/* 🔥 Icono del carrito */}
            <div className="estilo-cart mood" onClick={handleShow}>
                <img src={iconCart} style={{ width: "40px", height: "40px" }} />
                <span className='count' id="count">{totalProducts() || cart}</span>
            </div>

            {/* 🔥 Offcanvas que se abre desde la derecha */}
            <Offcanvas show={show} onHide={handleClose} placement="end" className="cart-offcanvas">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>🍔 Tu Pedido</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='offcanvas-body'>
                    {cart.length > 0 ? (
                        cart.map((item) => (
                            <ItemCart key={item.id} item={item} selectedSize={selectedSize} acomp={acomp} moduloBebida={moduloBebida} />
                        ))
                    ) : (
                        <p className="text-center h">No hay pedido cargado 🍔🍟</p>
                    )}

                    <Toaster position="top-center" reverseOrder={false} />
                </Offcanvas.Body>

                {/* 🔥 Footer con total y botones */}
                <div className="p-3 text-center">
                    <p><b>Total del pedido: ${totalPrice()}</b></p>
                    <Button variant="secondary" onClick={handleClose} className="me-2">
                        Volver
                    </Button>
                    {cart.length > 0 && (
                        <Link to="/checkout">
                            <Button variant="dark" onClick={handleClose}>
                                Realizar pedido
                            </Button>
                        </Link>
                    )}
                </div>
            </Offcanvas>
        </>
    );
}

export default CartWidget;
